import { useLazyQuery } from '@apollo/client';
import { SearchInput, SearchUserToolRoomResult } from '@bechtel/ht-types';
import { SEARCH_USER_TOOL_ROOMS } from '~/gql';

export const useSearchUserToolRooms = (fetchFromNetwork?: boolean) => {
  const [searchUserToolRooms, { data, loading, error, refetch, networkStatus, fetchMore }] = useLazyQuery<
    {
      searchUserToolRooms: SearchUserToolRoomResult;
    },
    { searchInput: SearchInput }
  >(SEARCH_USER_TOOL_ROOMS, {
    fetchPolicy: fetchFromNetwork ? 'network-only' : 'cache-first',
    notifyOnNetworkStatusChange: true,
  });
  return { searchUserToolRooms, data, loading, error, refetch, networkStatus, fetchMore };
};
